import { useGet } from '../../../../sharedModules/hooks/useQuery';
import { StatementScheduledEmail } from '../model';

const SCHEDULED_EMAILS_URL = '/collections/statement_scheduled_emails';

export function useStatementScheduledEmails(location: string, enabled = true) {
  return useGet<StatementScheduledEmail[]>({
    url: SCHEDULED_EMAILS_URL,
    params: { location },
    enabled: !!location && enabled,
  });
}
